import { render, staticRenderFns } from "./ImportCustomContentModalSection.vue?vue&type=template&id=35a2b384&scoped=true"
import script from "./ImportCustomContentModalSection.vue?vue&type=script&lang=js"
export * from "./ImportCustomContentModalSection.vue?vue&type=script&lang=js"
import style0 from "./ImportCustomContentModalSection.vue?vue&type=style&index=0&id=35a2b384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a2b384",
  null
  
)

export default component.exports